import { signInReturnPath } from 'src/lib/localData';
import { ROUTES } from 'src/routes';

// A sign-in never returns to a sign-in page, or to a callback whose URL carries a token.
const PATHS_WITHOUT_RETURN: string[] = [
  ROUTES.SIGN_IN,
  ROUTES.SIGN_IN_DEPRECATED,
  ROUTES.SIGN_UP,
  ROUTES.SIGN_UP_DEPRECATED,
  ROUTES.RESET_PASSWORD,
  ROUTES.ACCEPT_INVITE,
  ROUTES.OAUTH_CALLBACK,
  ROUTES.SAML_CALLBACK,
  ROUTES.MAGIC_LINK_CALLBACK,
  ROUTES.VERIFY_EMAIL_CALLBACK,
];

// Router state is lost on a full page load. The path in storage is not.
export const saveSignInReturnPath = (pathname: string, search: string): void => {
  if (PATHS_WITHOUT_RETURN.includes(pathname)) {
    return;
  }

  signInReturnPath.write(pathname + search);
};

// A sign-in returns to the path once. A later sign-in in the same tab does not.
export const takeSignInReturnPath = (): string | null => {
  const path = signInReturnPath.read();
  signInReturnPath.remove();
  return path;
};
